export default __webpack_public_path__ + "5b64461ed65c419772806e3a26cb74c0.png";